<template>
  <modal width="90%" class="comment" name="survey-modal" height="auto">
    <div class="display-message">
      <img :src="require('@/assets/icons/question-mark-pink.svg')" alt="Baby icon" />
    </div>

    <div>
      <p class="big pink">Geef een score op 5 vragen en help ons onderzoek enorm vooruit!</p>
      <div class="small">Dit neemt ± anderhalve minuut in beslag</div>
      <Button
        @click.native="$router.push({ name: 'Questionnaire' })"
        type="submit"
        title="Naar de vragenlijst"
        margin="25px auto 5px auto"
      ></Button>
    </div>
    <a class="small" href="#" @click.prevent="notToday()">Herinner me morgen</a>

    <div class="skip">
      <a class="small grey" href="#" @click.prevent="skip()">Ik wil de vragen niet invullen</a>
    </div>

    <p v-if="error" style="color: red;">{{ error }}</p>
  </modal>
</template>

<script>
import axios from 'axios';

export default {
  name: "SurveyModal",
  data: function() {
    return { error: null };
  },
  methods: {
    notToday: async function() {
      await axios
        .post(`${this.$backendRoot}/survey/nottoday`, {
          token: this.$session.get('token')
        })
        .then(res => {
          this.$modal.hide('survey-modal');
        })
        .catch(e => {
          this.consoleLog(e);
          this.error = e;
        });
    },
    skip: async function() {
      await axios
        .post(`${this.$backendRoot}/survey/skip`, {
          token: this.$session.get('token')
        })
        .then(res => {
          this.$modal.hide('survey-modal');
        })
        .catch(e => {
          this.consoleLog(e);
          this.error = e;
        });
    }
  }
};
</script>

<style scoped lang="scss">
a {
}

.likes {
  padding-bottom: 20px;
}

.big {
  font-size: 18px;
}

.small {
  font-size: 14px;
  max-width: 50%;
  margin: 0 auto;
}

.grey {
  color: grey;
}

.skip {
  margin-top: 40px;
}
</style>
